import React from 'react';

import { Header } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

import Flex from 'common/layout/helpers/Flex';
import Stack from 'common/layout/helpers/Stack';
import { ExportsDropdown } from 'subdomains/cpo/components/ExportsDropdown';
import { ExportFormat } from 'subdomains/cpo/types/exports';
import { SegmentLoader } from 'subdomains/cpo/components/SegmentLoader';

type Props = {
  loading?: boolean;
  handleExport?: (format: ExportFormat) => void;
};

export function PaymentTerminalsHeader({ loading, handleExport }: Props) {
  const { t } = useTranslation();

  if (loading) {
    return (
      <Stack>
        <Flex justify="space-between" align="center">
          <Header as="h2">{t('Payment Terminals')}</Header>
        </Flex>
        <SegmentLoader />
      </Stack>
    );
  }

  return (
    <Flex justify="space-between" align="center">
      <Header as="h2">{t('Payment Terminals')}</Header>
      {handleExport && <ExportsDropdown handleExport={handleExport} />}
    </Flex>
  );
}
